// === Phase B Task 4 — canvas_workflow slice ===
// Ephemeral, non-undoable. Owns visibility of the docked Workflow panel
// (CanvasWorkflowPanel) that mounts as the third editor column.
//
// docked        — when true, the panel takes real layout space beside the canvas.
//                 Default true so authors discover it without hunting for a toggle.
// expanded      — Round 27 Item 11: when true, the panel renders at double width
//                 (840px instead of 420px) via the .canvas-workflow-panel--expanded
//                 SCSS modifier. Toggled by an arrow button on the panel's left edge.
// nodePositions — Round 25 follow-up (closes user item 2 from Round 24): map of
//                 nodeId -> {x, y} saved drag positions. buildElementGraph
//                 computes defaults each render; the panel layers these saved
//                 positions on top so author-tuned layout survives rebuilds.
//                 "Reset positions" in the header clears the map back to the
//                 builder's defaults.
import {
  TOGGLE_CANVAS_WORKFLOW_DOCKED,
  TOGGLE_CANVAS_WORKFLOW_EXPANDED,
  TOGGLE_CANVAS_WORKFLOW_MINIMAP,
  SET_WORKFLOW_NODE_POSITION,
  CLEAR_WORKFLOW_NODE_POSITIONS,
  SET_EDGE_LABEL,
  CLEAR_EDGE_LABEL,
} from "../common/actions";

// minimapVisible defaults to true so authors discover the React Flow MiniMap
// overlay on the docked panel without hunting for a toggle. The panel header
// hosts an eye-icon button that flips this.
//
// edgeLabels — UI-only per-edge label override (double-click an edge label
// to edit). The trigger model itself is not mutated; the panel overlays
// edgeLabels[edgeId] on top of buildElementGraph's derived label, so a
// custom label survives reloads + item edits but a missing override falls
// back to the trigger-derived label.
const initialState = {
  docked: true,
  expanded: false,
  minimapVisible: true,
  nodePositions: {},
  edgeLabels: {},
};

export default function canvas_workflow(state = initialState, action) {
  switch (action.type) {
    case TOGGLE_CANVAS_WORKFLOW_DOCKED:
      return { ...state, docked: !state.docked };
    case TOGGLE_CANVAS_WORKFLOW_EXPANDED:
      return { ...state, expanded: !state.expanded };
    case TOGGLE_CANVAS_WORKFLOW_MINIMAP:
      return { ...state, minimapVisible: !state.minimapVisible };
    case SET_WORKFLOW_NODE_POSITION: {
      const { nodeId, position } = action.payload || {};
      if (!nodeId || !position) return state;
      const prev = state.nodePositions || {};
      return {
        ...state,
        nodePositions: {
          ...prev,
          [nodeId]: { x: position.x, y: position.y },
        },
      };
    }
    case CLEAR_WORKFLOW_NODE_POSITIONS:
      return { ...state, nodePositions: {} };
    case SET_EDGE_LABEL: {
      const { edgeId, label } = action.payload || {};
      if (!edgeId || typeof label !== "string") return state;
      const prev = state.edgeLabels || {};
      return {
        ...state,
        edgeLabels: {
          ...prev,
          [edgeId]: label,
        },
      };
    }
    case CLEAR_EDGE_LABEL: {
      const { edgeId } = action.payload || {};
      if (!edgeId) return state;
      const prev = state.edgeLabels || {};
      if (!(edgeId in prev)) return state;
      const next = { ...prev };
      delete next[edgeId];
      return { ...state, edgeLabels: next };
    }
    default:
      return state;
  }
}
